import { useCallback } from 'react';

import { usePlanTerminationModalStore } from '../store';

export default (
  additionalAction?: () => void,
) => {
  const handleChangeVisibility = usePlanTerminationModalStore((state) => state.handleChangeVisibility);
  const handleSetPlanId = usePlanTerminationModalStore((state) => state.handleSetPlanId);
  const handleSetPlanName = usePlanTerminationModalStore((state) => state.handleSetPlanName);
  const handleSetAdditionalAction = usePlanTerminationModalStore((state) => state.handleSetAdditionalAction);
  const handleSetIsHsaAccount = usePlanTerminationModalStore((state) => state.handleSetIsHsaAccount);
  const handleSetTerminationStatus = usePlanTerminationModalStore((state) => state.handleSetTerminationStatus);
  const handleSetTerminationDate = usePlanTerminationModalStore((state) => state.handleSetTerminationDate);
  const handleSetEditMode = usePlanTerminationModalStore((state) => state.handleSetEditMode);
  const handleSetHsaPlanStartDate = usePlanTerminationModalStore((state) => state.handleSetHsaPlanStartDate);


  const handleSetPlanTerminationDetails = useCallback(
    (
      id: string,
      name?: string,
      isHsa?: boolean,
      status?: string,
      hsaPlanStartDate?: string,
    ) => {
      handleSetPlanName(name);
      handleSetPlanId(id ? `${id}` : undefined);
      handleSetIsHsaAccount(isHsa);
      handleSetAdditionalAction(additionalAction);
      handleSetTerminationStatus(status);
      handleSetHsaPlanStartDate(hsaPlanStartDate);
    },
    [
      handleSetPlanName,
      handleSetPlanId,
      handleSetIsHsaAccount,
      handleSetAdditionalAction,
      additionalAction,
      handleSetTerminationStatus,
      handleSetHsaPlanStartDate,
    ],
  );

  const onClickAction = useCallback((
    id: string,
    name?: string,
    isHsa?: boolean,
    hsaPlanStartDate?: string,
  ) => {
    handleSetPlanTerminationDetails(id, name, isHsa, undefined, hsaPlanStartDate);
    handleChangeVisibility(true);
  }, [handleSetPlanTerminationDetails, handleChangeVisibility]);

  const handleOpenEditPlanTerminationModal = useCallback(
    (id: string, terminationDate?: string, name?: string, isHsa?: boolean) => {
      handleSetPlanTerminationDetails(id, name, isHsa);
      handleSetTerminationDate(terminationDate);
      handleSetEditMode(true);
      handleChangeVisibility(true);
    },
    [handleSetPlanTerminationDetails, handleSetTerminationDate, handleSetEditMode, handleChangeVisibility],
  );

  return {
    openPlanTerminationModal: onClickAction,
    handleSetPlanTerminationDetails,
    handleOpenEditPlanTerminationModal,
  };
};
